import Breakpoints from './Breakpoints';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

import { BoxArrowRight, PersonCircle } from 'react-bootstrap-icons';

import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

import { List } from 'react-bootstrap-icons';

import Logo_0 from './logo_0.png';
import { clearCurrentSession, getCurrentUserEmail } from './utils/profileStorage';

function Header() {
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [heroCollapse, setHeroCollapse] = useState(0);
    const animationFrameRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const userEmail = getCurrentUserEmail();
    const accountPath = userEmail ? '/profile' : '/login';
    const isHome = location.pathname === '/';
    const isActivePath = (path) =>
        path === '/'
            ? location.pathname === '/'
            : location.pathname === path || location.pathname.startsWith(`${path}/`);
    const getNavLinkClassName = (path, baseClassName) =>
        `${baseClassName}${isActivePath(path) ? ' is-active' : ''}`;
    const getAriaCurrent = (path) => (isActivePath(path) ? 'page' : undefined);

    const handleHomeClick = () => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        window.setTimeout(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        }, 0);
    };

    const handleLogout = () => {
        clearCurrentSession();
        setShowMobileMenu(false);
        navigate('/login');
    };

    useEffect(() => {
        const collapseStart = 150;
        const expandStart = 110;

        const updateFromScroll = () => {
            const y = window.scrollY;
            setHeroCollapse((prev) => {
                if (prev >= 1 && y < expandStart) {
                    return 0;
                }

                if (prev <= 0 && y > collapseStart) {
                    return 1;
                }

                return prev;
            });
            animationFrameRef.current = null;
        };

        const onScroll = () => {
            if (animationFrameRef.current !== null) {
                return;
            }
            animationFrameRef.current = window.requestAnimationFrame(updateFromScroll);
        };

        updateFromScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
            if (animationFrameRef.current !== null) {
                window.cancelAnimationFrame(animationFrameRef.current);
            }
        };
    }, []);

    return (
        <Navbar variant={'dark'} sticky={'top'} className="app-navbar" style={{ '--hero-progress': heroCollapse }}>
            <Container fluid={true} className="d-block px-3 header-shell">
                <Row className="header-main-row align-items-center flex-nowrap">
                    <Col xs="auto" lg="auto" xl="auto" className="header-logo-col">
                        <Link to="/" onClick={handleHomeClick}>
                            <Image src={Logo_0} className="header-logo" alt="Budgetvenlig" />
                        </Link>
                    </Col>

                    <Col className={'my-auto d-block d-' + Breakpoints.Computer + '-none header-mobile-title-col'}>
                        <Link to="/" className="mobile-site-title-wrap" onClick={handleHomeClick}>
                            <span className="mobile-site-title">Budgetvenlig</span>
                            <span className="site-beta">beta</span>
                        </Link>
                    </Col>

                    <Col xs="auto" className={'d-block my-auto d-' + Breakpoints.Computer + '-none burger-icon'}>
                        <button
                            type="button"
                            className="mobile-menu-button p-0 border-0 bg-transparent"
                            aria-label="Åbn menu"
                            onClick={() => setShowMobileMenu(true)}
                        >
                            <List className={'fa-align-right'} size="42" />
                        </button>
                        <Offcanvas
                            show={showMobileMenu}
                            onHide={() => setShowMobileMenu(false)}
                            placement="end"
                            className="mobile-menu-panel"
                        >
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title>Budgetvenlig</Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <p className="mobile-menu-kicker">Find billige hverdagsretter med ugens tilbud.</p>
                                <Link
                                    className={getNavLinkClassName('/', 'mobile-menu-link')}
                                    to="/"
                                    onClick={() => {
                                        setShowMobileMenu(false);
                                        handleHomeClick();
                                    }}
                                    aria-current={getAriaCurrent('/')}
                                >
                                    Forside
                                </Link>
                                <Link
                                    className={getNavLinkClassName('/recipes', 'mobile-menu-link')}
                                    to="/recipes"
                                    onClick={() => setShowMobileMenu(false)}
                                    aria-current={getAriaCurrent('/recipes')}
                                >
                                    Opskrifter
                                </Link>
                                <Link
                                    className={getNavLinkClassName('/vision', 'mobile-menu-link')}
                                    to="/vision"
                                    onClick={() => setShowMobileMenu(false)}
                                    aria-current={getAriaCurrent('/vision')}
                                >
                                    Vores vision
                                </Link>
                                <Link
                                    className={getNavLinkClassName('/pantry', 'mobile-menu-link')}
                                    to="/pantry"
                                    onClick={() => setShowMobileMenu(false)}
                                    aria-current={getAriaCurrent('/pantry')}
                                >
                                    Dit spisekammer
                                </Link>
                                <Link
                                    className={getNavLinkClassName('/contact', 'mobile-menu-link')}
                                    to="/contact"
                                    onClick={() => setShowMobileMenu(false)}
                                    aria-current={getAriaCurrent('/contact')}
                                >
                                    Kontakt os
                                </Link>
                                <Link
                                    className={getNavLinkClassName(accountPath, 'mobile-menu-link')}
                                    to={accountPath}
                                    onClick={() => setShowMobileMenu(false)}
                                    aria-current={getAriaCurrent(accountPath)}
                                >
                                    {userEmail ? 'Din profil' : 'Log ind'}
                                </Link>
                                {userEmail && (
                                    <button
                                        type="button"
                                        className="mobile-menu-link mobile-menu-logout"
                                        onClick={handleLogout}
                                    >
                                        <BoxArrowRight size={18} aria-hidden="true" />
                                        Log ud
                                    </button>
                                )}
                            </Offcanvas.Body>
                        </Offcanvas>
                    </Col>

                    <Col className={'my-auto d-none d-' + Breakpoints.Computer + '-block header-title-col'}>
                        <div className="header-title-row">
                            <Link to="/" className="site-title-wrap" onClick={handleHomeClick}>
                                <h1 className="site-title">Budgetvenlig</h1>
                                <span className="site-beta">beta</span>
                            </Link>

                            <div className="header-actions">
                                <Link
                                    to="/recipes"
                                    className={getNavLinkClassName('/recipes', 'header-nav-link header-nav-link-main')}
                                    aria-current={getAriaCurrent('/recipes')}
                                >
                                    Opskrifter
                                </Link>
                                <Link
                                    to="/vision"
                                    className={getNavLinkClassName('/vision', 'header-nav-link')}
                                    aria-current={getAriaCurrent('/vision')}
                                >
                                    Vores vision
                                </Link>
                                <Link
                                    to="/pantry"
                                    className={getNavLinkClassName('/pantry', 'header-nav-link')}
                                    aria-current={getAriaCurrent('/pantry')}
                                >
                                    Dit spisekammer
                                </Link>
                                <Link
                                    to="/contact"
                                    className={getNavLinkClassName('/contact', 'header-nav-link')}
                                    aria-current={getAriaCurrent('/contact')}
                                >
                                    Kontakt os
                                </Link>
                            </div>
                        </div>
                    </Col>

                    <Col className={'my-auto d-none d-' + Breakpoints.Computer + '-block header-login-col'} lg="auto">
                        <div className="header-account-actions">
                            <Link
                                to={accountPath}
                                className={getNavLinkClassName(accountPath, 'header-login-button')}
                                aria-current={getAriaCurrent(accountPath)}
                                aria-label={userEmail ? 'Åbn din profil' : 'Log ind'}
                            >
                                <PersonCircle className="my-auto login-icon" size={22} />
                                <span>{userEmail ? 'Profil' : 'Log ind'}</span>
                            </Link>
                            {userEmail && (
                                <button
                                    type="button"
                                    className="header-logout-button"
                                    onClick={handleLogout}
                                >
                                    <BoxArrowRight size={16} aria-hidden="true" />
                                    Log ud
                                </button>
                            )}
                        </div>
                    </Col>
                </Row>

                {isHome && (
                    <Row className="header-hero-row" style={{ '--hero-progress': heroCollapse }}>
                        <Col xs={12}>
                            <div className="header-hero-copy text-center">
                                <p className="header-hero-title">UGENS BEDSTE MADPLAN FOR PRISEN</p>
                                <p className="header-hero-subtitle">Baseret på tilbud i supermarkeder nær dig</p>
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>
        </Navbar>
    );
}

export default Header;
